export default __webpack_public_path__ + "static/media/landing-page-main-image.93d2e015.jpg";